/**
 * Builds a jurisdiction id → display name lookup from the user's
 * `jurisdictionNameMap` (`{ [jurisdictionId]: name }`). Ids match
 * case-insensitively (timeline `partner` values are lower-case abbreviations),
 * and an id with no known name falls back to the trimmed id itself.
 *
 * @param {Object} jurisdictionNameMap
 * @returns {(jurisdictionId: string) => string}
 */
export const buildJurisdictionNameLookup = (jurisdictionNameMap = {}) => {
    const namesByLowerId = Object.entries(jurisdictionNameMap || {}).reduce((acc, [id, name]) => {
        const key = String(id).trim().toLowerCase();
        if (key && name) acc[key] = name;
        return acc;
    }, {});

    return (jurisdictionId) => {
        const id = String(jurisdictionId ?? '').trim();
        return namesByLowerId[id.toLowerCase()] || id;
    };
};

/**
 * One-off form of `buildJurisdictionNameLookup`.
 *
 * @param {Object} jurisdictionNameMap
 * @param {string} jurisdictionId
 * @returns {string}
 */
export const resolveJurisdictionName = (jurisdictionNameMap, jurisdictionId) => (
    buildJurisdictionNameLookup(jurisdictionNameMap)(jurisdictionId)
);
